module.exports = __webpack_public_path__ + "img/horizontal_7_6_pp1_9016.03cfe2f9.png";